import React from 'react';
import { Link } from 'react-router-dom';
import styles from './doubts.scss';
import cx from 'classnames';
import globestyle from '../../sass/global.scss';

class doubtDetail extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={cx(styles.main_block)}>
                <div className={cx('row')}>
                    <div className={cx('col')} >
                        <Link to='#' className={cx(styles.back_arrow)}>
                            <i className={cx('fa fa-arrow-left')}></i>
                        </Link>
                    </div>
                </div>
                <div className={cx('row')}>
                    <div className={cx('col-md-12')}>
                        <h1 className={cx(styles.doubt_detail_title)}>1. TEST SERIES NAME <br />
                            <span>ASKED ON 12-12-18</span>
                        </h1>
                    </div>
                </div>
                <div className={cx('row')}>
                    <div className={cx('col-md-5')}>
                        <img src={require('images/big_doubt.jpg')} className={cx('img-fluid')} alt='Paper' />
                    </div>
                    <div className={cx('col-md-7')}>
                        <div className={cx('row')}>
                            <div className={cx('col-md-12')}>
                                <p>t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
                            </div>
                            <div className={cx('col-md-12')}>
                                <form>
                                    <div className={cx('form-group')}>
                                        <fieldset className={cx(globestyle.fset, globestyle.lessradius)}>
                                            <legend className={cx(globestyle.legend)}>About what it is</legend>
                                            <textarea placeholder='Reply here' className={cx('form-control')} rows='4' />
                                        </fieldset>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}


export default doubtDetail;
